module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bloco-protocolo container container_com-fundo container_com-margem"
  }, [_c('h2', {
    staticClass: "titulo titulo_grande u-margem-inferior-media"
  }, [_vm._v("Protocolo")]), _vm._v(" "), _c('div', {
    staticClass: "linha-de-dados"
  }, [_c('span', {
    staticClass: "item-de-dado"
  }, [_c('strong', [_vm._v("NUP (Processo):")]), _vm._v(" "), (!_vm.existeNumeroDoProcesso) ? _c('span', [_vm._v("Ainda não gerado")]) : _c('span', [_vm._v(_vm._s(_vm.numeroDoProcesso))])]), _vm._v(" "), _c('span', {
    staticClass: "item-de-dado"
  }, [_c('strong', [_vm._v("Operação bancária:")]), _vm._v(" "), _c('span', {
    staticClass: "texto"
  }, [_vm._v(_vm._s(_vm.operacaoBancariaFormatada || 'Não informado'))])]), _vm._v(" "), _c('span', {
    staticClass: "item-de-dado"
  }, [_c('strong', [_vm._v("Origem (assinatura):")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.origemDaAssinatura || 'Não informado'))])]), _vm._v(" "), _c('span', {
    staticClass: "item-de-dado item-de-dado_situacao-atual"
  }, [_c('strong', [_vm._v("Situação atual:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.status || 'Não informado'))])])]), _vm._v(" "), (_vm.situacaoDoPrazoDoDossie) ? _c('prazo-do-dossie', {
    attrs: {
      "situacao": _vm.situacaoDoPrazoDoDossie
    },
    on: {
      "prorrogar": function($event) {
        return _vm.$emit('prorrogar')
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-42edc6a5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42edc6a5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/controle-de-solicitacoes/detalhes-da-solicitacao/components/ProtocoloDaSolicitacao.vue
// module id = 1111
// module chunks = 1